import React from "react";
import { useSelector, useDispatch } from "react-redux";

// Actions
import { toggleRouteTypeSelection } from "../../../actions/org/OrgRouteTypesActions";

// Components
import CheckBox from "../../../components/check-box/CheckBox";
import { HeaderWithActionButton } from "./PlanningUtils";

// Arterial Route Checkbox List
function ArterialRouteCheckboxList({
  data = [],
  selectedMap = {},
  onCheckboxChange = () => {},
  appliedFiltersDetailsMap = {},
}) {
  if (data.length === 0) {
    return null;
  }

  const {
    appliedFilterOrder = {},
    isMediaTypesApplied = false,
    isZonesApplied = false,
    firstAppliedFilterOptions = {},
    secondAppliedFilterOptions = {},
  } = appliedFiltersDetailsMap || {};
  const isFilteredOption = isZonesApplied || isMediaTypesApplied;
  const { routeTypes: firstRouteTypes = [] } = firstAppliedFilterOptions || {};
  const { routeTypes: secondRouteTypes = [] } =
    secondAppliedFilterOptions || {};
  const isRouteTypeFirstApplied =
    appliedFilterOrder?.firstApplied === "routeType";
  const isRouteTypeSecondApplied =
    appliedFilterOrder?.secondApplied === "routeType";

  const isFirstAppliedPresent = !!appliedFilterOrder?.firstApplied;
  const isSecondAppliedPresent = !!appliedFilterOrder?.secondApplied;

  return (
    <div className="px-3">
      {data.map((eachData, index) => {
        // logic to filter options
        if (isFilteredOption && !isRouteTypeFirstApplied) {
          if (isSecondAppliedPresent) {
            if (isRouteTypeSecondApplied) {
              if (!firstRouteTypes.includes(eachData)) {
                return;
              }
            }

            if (!isRouteTypeSecondApplied) {
              if (!secondRouteTypes.includes(eachData)) {
                return;
              }
            }
          }

          if (isFirstAppliedPresent && !isRouteTypeFirstApplied) {
            if (!firstRouteTypes.includes(eachData)) {
              return;
            }
          }
        }

        return (
          <div className="d-flex justify-content-between mt-2" key={index}>
            <p className="mb-0" title={eachData}>
              {eachData}
            </p>
            <CheckBox
              boxStyle="mb-0"
              checkBoxKey={eachData}
              showLabel={false}
              checked={selectedMap[eachData] || false}
              onChange={() => onCheckboxChange(eachData)}
            />
          </div>
        );
      })}
    </div>
  );
}

// Arterial Route Tab
export default function ArterialRouteTab({
  handleTabHeaderBtnClick = () => {},
  tabHeaderBtnLoading = false,
  appliedFiltersDetailsMap = {},
}) {
  const dispatch = useDispatch();

  // route types
  const routeTypes = useSelector((state) => state.orgRouteTypes.routeTypes);

  // Selected Arterial Routes Map
  const selectedArterialRoutesMap = useSelector(
    (state) => state.orgRouteTypes.selectedArterialRoutes
  );

  function handleCheckboxChange(routeType) {
    dispatch(toggleRouteTypeSelection(routeType));
  }

  return (
    <>
      <HeaderWithActionButton
        title="Route Type"
        buttonText="Confirm"
        onButtonClick={handleTabHeaderBtnClick}
        buttonLoading={tabHeaderBtnLoading}
      />

      <ArterialRouteCheckboxList
        data={routeTypes}
        selectedMap={selectedArterialRoutesMap}
        onCheckboxChange={handleCheckboxChange}
        appliedFiltersDetailsMap={appliedFiltersDetailsMap}
      />
    </>
  );
}
